import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    
    // Log 404 to database
    supabase.from("page_404_errors").insert({
      path: location.pathname + location.search,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent || null,
    }).then(({ error }) => {
      if (error) console.error("Failed to log 404:", error);
    });
  }, [location.pathname]);

  return <Navigate to="/" replace />;
};

export default NotFound;
